module.exports = __webpack_public_path__ + "img/brand-20.87c60c37.png";